export enum TrackingEventNameEnum {
  LOGIN_PLATFORM = 'LOGIN_PLATFORM',
  ENROLLMENT_STARTED = 'ENROLLMENT_STARTED',
  ENROLLMENT_DATA_SENT = 'ENROLLMENT_DATA_SENT',
  ENROLLMENT_DOCUMENTS_SENT = 'ENROLLMENT_DOCUMENTS_SENT',
  ENROLLMENT_CONTRACT_ACCEPTED = 'ENROLLMENT_CONTRACT_ACCEPTED',
  CHECKOUT_VIEWED = 'CHECKOUT_VIEWED',
  PAYMENT_SENT = 'PAYMENT_SENT',
  PAYMENT_CONFIRMED = 'PAYMENT_CONFIRMED',
  PAGE_VIEW = 'PAGE_VIEW',
  COMPLEMENTARY_ACCESS = 'COMPLEMENTARY_ACCESS',
}
